import { Component, OnInit } from '@angular/core';

import { StatusMonitorUpdate, StatusMonitorService } from '../services/status-monitor.service';
import { StatusHistoryService } from '../services/status-history.service';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {
  public lastUpdate: StatusMonitorUpdate;

  constructor(
    public statusMonitor: StatusMonitorService,
    statusHistory: StatusHistoryService
  ) {
    if (statusHistory.data.length === 0) {
      this.lastUpdate = new StatusMonitorUpdate();
    } else {
      this.lastUpdate = statusHistory.data[statusHistory.data.length - 1];
    }
  }

  ngOnInit() {
    this.statusMonitor.updated.subscribe(($event: StatusMonitorUpdate) => {
      this.lastUpdate = $event;
    });
  }

}



// WEBPACK FOOTER //
// /builds/iws/vanenet/src/app/main/status/status.component.ts